import { Toaster as SonnerToaster } from 'sonner';
import type { ComponentProps } from 'react';

/**
 * Toaster.
 *
 * Thin wrapper around sonner that bakes in our dark + Theia-orange
 * theme + atmospheric surfaces. Use the imperative API from sonner
 * elsewhere:
 *
 *   import { toast } from 'sonner';
 *   toast.success('Saved');
 *   toast.error('Failed', { description: '...' });
 */

type ToasterProps = ComponentProps<typeof SonnerToaster>;

export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position="top-right"
      theme="dark"
      // Closer-stacked variant — more compact than sonner's default.
      visibleToasts={4}
      // CSS variables here override sonner's defaults to match our
      // token system. The component reads these and applies them.
      style={
        {
          '--normal-bg': '#101010',
          '--normal-border': '#1c1c1c',
          '--normal-text': '#f5f5f5',
          '--success-bg': '#0a1f10',
          '--success-border': '#1f4a2a',
          '--success-text': '#86efac',
          '--error-bg': '#1f0a0a',
          '--error-border': '#5b1f1f',
          '--error-text': '#fca5a5',
        } as React.CSSProperties
      }
      toastOptions={{
        // Tighter typography + radius to match our cards.
        classNames: {
          toast:
            'rounded-md text-xs font-medium',
        },
      }}
      {...props}
    />
  );
}
